import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { Tag } from 'data/entities/entities';
import { TagService } from "data/service/tag-service";

@autoinject()
export class AddNewTagDialog {

	tag: Tag;
	title: string = "Add New Tag";

	constructor(private dialogController: DialogController, private tagService:TagService) {
		this.dialogController.settings.lock = true;
		this.tag = this.tagService.getNew();
	}

	cancel() {
		this.dialogController.cancel();
	}

	saveNew() {
		this.tag.save();
		this.dialogController.ok(this.tag);//Return the new item to the caller as the "Output";
	}

}